const LabelDisplayedRows = ({ count, from, to }) => (<>{`${from}-${to} de ${count !== -1 ? count : `más de: ${to}`}`}</>)

export default LabelDisplayedRows
